import script from "./GeneticIdResultView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneticIdResultView.vue?vue&type=script&setup=true&lang=ts"

import "./GeneticIdResultView.vue?vue&type=style&index=0&id=667bf50b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src839921157/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667bf50b"]])

export default __exports__